import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" />
        <p>
          Coming Soon To App Stores...
        </p>
      </header>
    </div>
  );
}

export default App;
